import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { UserProvider, useUser } from "./context/UserContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ChatPanel from "./components/ChatPanel";

import Landing from "./pages/Landing";
import BrowseCreators from "./pages/BrowseCreators";
import CreatorProfile from "./pages/CreatorProfile";
import Orders from "./pages/Orders";
import OrderDetail from "./pages/OrderDetail";
import Dashboard from "./pages/Dashboard";
import Payments from "./pages/Payments";
import Wallet from "./pages/Wallet";
import Settings from "./pages/Settings";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import EmailSent from "./pages/EmailSent";
import VerifyEmail from "./pages/VerifyEmail";
import Faq from "./pages/Faq";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Admin from "./pages/Admin";
import PayLtc from "./pages/PayLtc";

function Protected({ children }) {
  const { user } = useUser();
  const location = useLocation();
  if (user === undefined) {
    return (
      <div data-testid="auth-loading" className="max-w-3xl mx-auto px-6 py-20 text-[#606070]">
        Loading…
      </div>
    );
  }
  if (user === null) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}

function App() {
  return (
    <div className="App min-h-screen">
      <BrowserRouter>
        <UserProvider>
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/creators" element={<BrowseCreators />} />
              <Route path="/creators/:id" element={<CreatorProfile />} />
              <Route path="/orders" element={<Protected><Orders /></Protected>} />
              <Route path="/orders/:id" element={<Protected><OrderDetail /></Protected>} />
              <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
              <Route path="/payments" element={<Protected><Payments /></Protected>} />
              <Route path="/wallet" element={<Protected><Wallet /></Protected>} />
              <Route path="/settings" element={<Protected><Settings /></Protected>} />

              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              {/* Backwards-compatible aliases for old marketing links */}
              <Route path="/signup/company" element={<Navigate to="/signup?role=company" replace />} />
              <Route path="/signup/creator" element={<Navigate to="/signup?role=creator" replace />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/email-sent" element={<EmailSent />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/pay/:orderId" element={<Protected><PayLtc /></Protected>} />
            </Routes>
          </main>
          <Footer />
          <ChatPanel />
          <Toaster
            position="bottom-right"
            theme="dark"
            toastOptions={{
              style: { background: "#0a0a14", border: "1px solid #15152a", color: "#fff" },
            }}
          />
        </UserProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
